<template>
  <div>
    <v-chart
      :option="polar"
      autoresize
      :style="{ height: '320px', width: '100%' }"
      @click="nextClick"
    />
  </div>
</template>

<script>
import _ from 'lodash'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import variables from '@/styles/variables.scss'

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent
])

export default {
  components: {
    VChart
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      polar: {},
      data: [],
      color: []
    }
  },
  created() {
    this.chart()
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.data = []
        this.color = []

        let countColor = 0
        const total = this.item.visit || 1

        let child = this.item.child.map(o => ({ ...o }))

        child = _.orderBy(child, ['visit'], ['desc'])

        if (child && child.length > 10) {
          const other = child.slice(10)
          child = child.slice(0, 10)
          child.push({
            name: 'Other',
            visit: _.sumBy(other, 'visit')
          })
        }

        for (const obj of child) {
          if (obj.name === 'Ended By User') {
            this.color.push(this.$getVoiceColor[0])
          } else {
            if (countColor > this.$getGrayColor.length - 1) countColor = 0

            this.color.push(this.$getGrayColor[countColor])
            countColor += 1
          }

          obj.value = obj.visit
          obj.percent_visit = parseFloat((obj.visit * 100) / total).toFixed(2)

          this.data.push(obj)
        }

        this.chart()
      }
    }
  },
  methods: {
    chart() {
      this.polar = {
        textStyle: {
          fontFamily: variables.fontFamily
        },
        color: this.color,
        title: {
          text: 'Next checkpoints',
          left: 10
        },
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return `${params.name}: ${params.data.value.toLocaleString()} (${
              params.percent
            }%)`
          }
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            center: ['50%', '55%'],
            radius: ['35%', '50%'],
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            label: {
              formatter: params => {
                return `${params.name} \n ${params.percent}%`
              }
            },
            labelLine: {
              show: true
              // length: 5,
              // length2: 10
            },
            data: this.data
          }
        ],
        animationDuration: 2000
      }
    },
    nextClick(data) {
      if (data.name !== 'Other') this.$emit('nextClick', data.name)
    }
  }
}
</script>
